import { useMutation } from '@tanstack/react-query'
import { App } from 'antd'
import { VoucherQueryParams } from '../../../pages/reporting/vouchers/types'
import { Company } from '../../../types/company/Company'
import { autoDownload } from '../../../utils/helpers'
import { getVoucherXlsx } from '../service/voucherService'
import { useDimensionQuery } from '../../dimension/hooks/hooks'

export const useXlsxDownload = (
  requestParams: Partial<VoucherQueryParams>,
  companyId?: Company['id'],
  dimensions?: string
) => {
  const { message } = App.useApp()
  const dimensionQuery = useDimensionQuery()
  if (!requestParams || Object.keys(requestParams).length === 0) {
    throw new Error('Request parameters are required for XLSX download')
  }

  const mutation = useMutation({
    mutationFn: () => getVoucherXlsx(requestParams, companyId, dimensions ?? dimensionQuery),
    onSuccess: (data: Blob) => {
      autoDownload('transactions.xlsx', data)
    },
    onError: error => {
      console.error('Download failed:', error)
      message.error('Failed to download file')
    }
  })

  return {
    download: mutation.mutate,
    isDownloading: mutation.isPending,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess
  }
}
